import { reactive } from 'vue'
import env from '@/services/environment'
import { TokenInfoService } from '@/services/auth/common/tokenInfo'
import store from '@/store/index'
import router from '@/router/index'
export const LogOutService = reactive({
  logoutApp () {
    // $bus.$emit('logout')
    store.dispatch('ui/showMask')
    window.location.href = this.getLogoutUrl()
    setTimeout(() => {
      sessionStorage.removeItem('accessInfo')
      TokenInfoService.clearBrowserCookies()
      router.push({ name: 'LoginSSO' })
      store.dispatch('ui/hideMask')
      location.reload()
    }, 1500)
  },

  getLogoutUrl () {
    const aToken = TokenInfoService.tokenData()
    const logoutBaseUrl = env.getEnvVariable('VUE_APP_SSO_LOGOUT_URL')
    const idTokenHint = `?id_token_hint=${aToken.accessToken}`
    const clientId = `&client_id=${env.getEnvVariable('VUE_APP_APP_CODE')}`

    return logoutBaseUrl.concat(idTokenHint).concat(clientId)
    // return `https://ppd.np.idp.carrefour.com:443/am/oauth2/realms/root/realms/sso/connect/endSession?id_token_hint=${aToken.accessToken}&client_id=openid_penelope_ppd`
  }
})
